(() => {
  'use strict';

  const sticky = document.querySelector('product-sticky-add-to-cart[main-product-form]');
  if (!sticky) return;

  const form = document.getElementById(sticky.getAttribute('main-product-form'));
  const footer = document.querySelector('.shopify-section--footer');
  const media = window.matchMedia('(max-width: 999px)');
  if (!form) return;

  const update = () => {
    if (!media.matches) {
      sticky.classList.remove('dreissigacker-is-visible');
      return;
    }

    const formRect = form.getBoundingClientRect();
    const formVisible = formRect.bottom > 0 && formRect.top < window.innerHeight;
    const footerRect = footer ? footer.getBoundingClientRect() : null;
    const footerVisible = footerRect ? footerRect.bottom > 0 && footerRect.top < window.innerHeight : false;

    sticky.classList.toggle('dreissigacker-is-visible', !formVisible && !footerVisible);
  };

  const observer = new IntersectionObserver(update);
  observer.observe(form);
  if (footer) observer.observe(footer);
  media.addEventListener('change', update);
  window.requestAnimationFrame(update);
})();
